import { Injectable } from '@angular/core';

import { Oauth2Service } from '@common';

import { BrowseContextServiceBase } from '../../baseBtl/context/child/browse-context.service';
import { JsonProduct } from '../../catalog/products/interface/context';

/**
 * Created by fruysshaert on 23/03/2017.
 */
import { ContextInterface } from '../context.interface';
import { AcquisitionContextService } from './acquisition-context.service';
import { CustomerContextService } from './customer-context.service';
import { UserContextService } from './user-context.service';

@Injectable({
    providedIn: 'root',
})
export class BrowseContextService extends BrowseContextServiceBase implements ContextInterface {
    constructor(
        acquisitionContextService: AcquisitionContextService,
        customerContextService: CustomerContextService,
        userConstextService: UserContextService,
        oauth2Service: Oauth2Service,
    ) {
        super(acquisitionContextService, customerContextService, userConstextService, oauth2Service);
    }

    public isProductAvailable(product: JsonProduct): boolean {
        if (this.typeParcours !== BrowseContextService.TYPES.RENEW) {
            return false;
        }

        if (['phone', 'box'].includes(product.type_id) && !product.categories.includes('renewal_rcbt')) {
            return false;
        }

        return true;
    }
}
